'use client';

import { useGeoContext } from '../contexts/GeoProvider';

const PARTICIPATING_COUNTRIES = ['US', 'CA'];

const useDisplayBestBuy = (): boolean => {
  const { countryData } = useGeoContext();
  const countryCode = countryData?.countryCode;

  return PARTICIPATING_COUNTRIES.includes(countryCode!);
};

export default useDisplayBestBuy;
